module.exports = __webpack_public_path__ + "img/payment_icon_csobgtw.1742d28f.png";